import React,{useEffect} from "react"
import NavBar1 from '../../components/Navbar1/NavBar1';
import Footer from '../../components/Footer/Footer'; 
import SideBar from '../../components/SideBar/SideBar';
import Workouts from "../../components/Workouts/Workouts"
import {connect} from "react-redux";
import Spinner from "../../components/Spinner/Spinner";
import * as actions from "../../store/actions/index"
const WorkoutPlans = (props) =>{
    useEffect(()=>{
        props.onFetchWorkoutPlansClient();
    },[])
    return(
        <>
         <NavBar1 /> 
        <SideBar>
            <Footer>

                {
                    !props.workoutsLoading?
                    props.plans.map((plan,index)=>(
                       
                       <Workouts plan={plan} index={index}/>
                    )):<Spinner/>
                }
                
 
            </Footer>

        </SideBar>
             
         
        </>
    );
}
const mapStateToProps = state=>{
    return {
        plans:state.workouts.workouts,
        workoutsLoading:state.workouts.workoutsLoading
    }
}
const mapDispatchToProps = dispatch=>{
    return{
        onFetchWorkoutPlansClient:()=>dispatch(actions.fetchWorkoutPlansClient())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(WorkoutPlans);;